import {
	ADD_FILTER,
	UPDATE_FILTER,
	SET_FILTERS,
	DELETE_FILTER
} from "../../actions/DashboardDesigner/actionContants";

const filters = (state = [], action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type:
		 *  filter:
		 * }
		 */
		case ADD_FILTER:
			return [...state, action.filter];
		/**
		 * action: {
		 *  type:
		 *  payload:
		 *  filterId:
		 * }
		 */
		case UPDATE_FILTER:
			var { filterId, payload } = action;
			let targetfilterObj = state.find(e => e.id === filterId);
			let updatedfilterObj = { ...targetfilterObj, ...payload };
			return state.map(filter => {
				if (filter.id === filterId) {
					return updatedfilterObj;
				} else {
					return { ...filter };
				}
			});
		/**
		 * action: {
		 *  filterId:
		 * }
		 */
		case DELETE_FILTER:
			var { filterId } = action;
			return state.filter(filter => filter.id !== filterId);
		case SET_FILTERS:
			return action.data;
		default:
			return state;
	}
};

export default filters;
